<template>
    <div class="tab"><van-nav-bar
        :title="title"
        :left-text="leftText"
        :fixed ="fixed"
        left-arrow
        :right-text="rightText"
        @click-left="onClickLeft"
        @click-right="onClickRight"
        @nav-bar-height="height"
        /></div>
      
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import { NavBar } from 'vant';
import { Dialog } from 'vant';


Vue.use(NavBar);
export default {
  name: 'margin',
  data () {
    return {
        height:'100px',
        leftText:'返回'
    }
  },
   props: {
    title:{
      type:String
    },
    fixed:{
      type:Boolean
    },
    rightText:{
      type:String
    }
   },
   methods: {
    onClickLeft() {
       if(this.$props.title == '首页'){
            Dialog.confirm({
                title: '温馨提示',
                message: '确认要退出登录吗？',
            })
            .then(() => {
                // on confirm
                this.$storage.remove('token')
                this.$router.go(-1);
            })
            .catch(() => {
                // on cancel
            });
       }else{
           this.$router.go(-1);
       }
    },
    onClickRight() {
      window.scrollTo(0, 0);
    },
  },
  mounted(){
    if(this.$props.title=='首页'){
        this.leftText = '退出登录'
    }else{
      this.leftText = '返回'
    }
  }
}
</script>

<style scoped>
.van-nav-bar__left, .van-nav-bar__right {
  font-size: 16px;
}
.tab {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue